module.exports = __webpack_public_path__ + "static/media/ec.90a130cb.svg";